import React, { useEffect, useMemo, useState } from 'react'
// import Layout from '../../Layout'

import PieChartMaint from './charts/PieChartMaint';
import ChartFleetSize from './charts/ChartFleetSize';
import { Box, Grid, Tooltip, Typography } from '@mui/material';
import Card from '../Dashboard/components/Card/Card';
import { useSelector } from 'react-redux';
import MultiLinearProgress from './charts/MultiLinearProgress';
import CustomTextField from '../../Components/common/TextField';
import MenuItem from '../../Components/common/MenuItem';
import Button from '../../Components/common/Button';
import onlineSvg from "../../assets/dashboard/TotalInvoices.svg";
import MaintRequest from "../../assets/dashboard/MaintRequest.svg";
import Scrollbar from 'react-scrollbars-custom';
import { fetchCarbonFootPrint, fetchCostbyVehicleClassification, fetchFleetSize, fetchMaintenaceRequest, fetchMaintenanceCosts, fetchTop20HighestMaintCost, fetchTotalInvoices, fetchTotalMaintenanceRequest, fetchUsedPackages, fetchUsedParts, fetchUsedServices } from './apiServices';
import { getToFrom } from '../../Helpers';
import TotalInvoicesCard from './components/TotalInvoicesCard';
import { MaintenanceItemEmpty } from './components/Empty';
import CostList from './components/CostList';
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import co2svg from "../../assets/dashboard/co2img.svg";
import InfoIcon from "@mui/icons-material/Info";

const currencies = [
    { label: "MTD", value: 1 },
    { label: "Last Month", value: 2 },
    { label: "Last 3 months", value: 3 },
    { label: "YTD", value: 4 },
    { label: "Last Year", value: 5 },
    { label: "ALL", value: 6 },
];
const transformCostData = (data) => {
    if (!data || typeof data !== "object" || Object.keys(data).length === 0) {
        return [];
    }

    return Object.entries(data).map(([plateNumber, cost]) => ({
        plateNumber,
        cost,
    }));
};

const buttons = [
    { label: 'Top Services', value: 'topServices' },
    { label: 'Top Parts', value: 'topParts' },
    { label: 'Top Packages', value: 'topPackages' },
];
const processMaintRequest = (rawData) => {
    const entries = Object.entries(rawData);
    const max = Math.max(...entries.map(([, value]) => value)) || 1;

    return entries.map(([key, value]) => ({
        itemName: key,
        usedCount: value,
        usedCountPercentage: (value / max) * 100
    }));
};


const MaintenanceDashboard = (props) => {
    const themecolors = useSelector((state) => state.themeColors);
    const logInUser = useSelector((state) => state.logInUsers);

    const [mode, setMode] = useState("costPerDay");
    const [serviceBtn, setServiceBtn] = useState("topServices");

    const [maintenanceValues, setMaintenanceValues] = useState({
        first: "6",
        second: "6",
        third: "6",
        fourth: "6",
    });

    const [maintenanceDates, setMaintenanceDates] = useState({
        first: { to: null, from: null },
        second: { to: null, from: null },
        third: { to: null, from: null },
        fourth: { to: null, from: null },
    });

    const [maintState, setMaintState] = useState({
        maintRequestCategory: {},
        partsMaintRequest: null,
        serviceMaintRequest: null,
        packageMaintRequest: null,
    });

    const [fleetSize, setFleetSize] = useState([]);
    const [vehicleMaintenanceCostPerDay, setVehicleMaintenanceCostPerDay] = useState(null);
    const [vehicleMaintenanceCostPerKm, setVehicleMaintenanceCostPerKm] = useState(null);

    const [usedService, setUsedService] = useState([]);
    const [usedParts, setUsedParts] = useState([]);
    const [usedPackages, setUsedPackages] = useState([]);

    const [isFetchingServices, setIsFetchingServices] = useState(false);
    const [isFetchingMaintenanceReqst, setIsFetchingMaintenanceRequest] = useState(false);
    const [isFetchingTopHighest, setIsFetchingTopHighest] = useState(false);

    const [totalInvoices, setTotalInvoices] = useState(0);
    const [totalMaintenanceRequest, setTotalMaintenanceRequest] = useState(0);
    const [vehicleClassificationData, setVehicleClassificationData] = useState(null);
    const [top20HighestMaintCost, setTop20HighestMaintCost] = useState([]);

    const handleMaintenancetTimeChange = (event) => {
        const { name, value } = event.target;
        const { to, from } = getToFrom(value);
        setMaintenanceValues((prev) => ({ ...prev, [name]: value }));
        setMaintenanceDates((prev) => ({ ...prev, [name]: { to, from } }));
    };

    const convertToArray = (data) => Object.entries(data).map(([name, cost]) => ({ name, cost }));

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;

        fetchFleetSize(signal)
            .then(setFleetSize)
            .catch((error) => {
                if (error.name !== "CanceledError") console.error(error);
            });

        return () => controller.abort();
    }, []);

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;

        fetchMaintenanceCosts(signal)
            .then(({ costPerDay, costPerKm }) => {
                setVehicleMaintenanceCostPerDay(costPerDay);
                setVehicleMaintenanceCostPerKm(costPerKm);
            })
            .catch((error) => {
                if (error.name !== "AbortError") console.error(error);
            });

        return () => controller.abort();
    }, []);

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;

        const fetchData = async () => {
            setIsFetchingServices(true);
            try {
                const { to, from } = maintenanceDates.fourth;
                if (serviceBtn === "topServices") await fetchUsedServices(to, from, signal).then(setUsedService);
                else if (serviceBtn === "topParts") await fetchUsedParts(to, from, signal).then(setUsedParts);
                else if (serviceBtn === "topPackages") await fetchUsedPackages(to, from, signal).then(setUsedPackages);
            } catch (err) {
                if (err.name !== "CanceledError") console.error("Fetch error:", err);
            } finally {
                setIsFetchingServices(false);
            }
        };
        fetchData();

        return () => controller.abort();
    }, [serviceBtn, maintenanceDates.fourth.to, maintenanceDates.fourth.from]);

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;

        setIsFetchingMaintenanceRequest(true);
        fetchMaintenaceRequest(maintenanceDates.third.to, maintenanceDates.third.from, setMaintState,signal)
            .catch((error) => {
                if (error.name !== "CanceledError") console.error(error);
            })
            .finally(() => setIsFetchingMaintenanceRequest(false));

        return () => controller.abort();
    }, [maintenanceDates.third.to, maintenanceDates.third.from]);

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;

        Promise.all([
            fetchTotalInvoices(maintenanceDates.first.to, maintenanceDates.first.from,signal),
            fetchTotalMaintenanceRequest(maintenanceDates.first.to, maintenanceDates.first.from,signal),
        ])
            .then(([invoices, maintenance]) => {
                setTotalInvoices(invoices);
                setTotalMaintenanceRequest(maintenance);
            })
            .catch((error) => {
                if (error.name !== "CanceledError") console.error(error);
            });

        return () => controller.abort();
    }, [maintenanceDates.first.to, maintenanceDates.first.from]);
    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;

        fetchCostbyVehicleClassification(maintenanceDates.second.to, maintenanceDates.second.from, signal)
            .then((data) => setVehicleClassificationData(convertToArray(data)))
            .catch((error) => {
                if (error.name !== "CanceledError") console.error(error);
            });

        return () => controller.abort();
    }, [maintenanceDates.second.to, maintenanceDates.second.from]);

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;

        setIsFetchingTopHighest(true);
        fetchTop20HighestMaintCost(signal)
            .then(setTop20HighestMaintCost)
            .catch((error) => {
                if (error.name !== "CanceledError") console.error(error);
            })
            .finally(() => setIsFetchingTopHighest(false));

        return () => controller.abort();
    }, []);
    const [carbonFootPrint, setCarbonFootPrint] = useState(null);
    const [isFetchingCarbonFootPrint, setIsFetchingCarbonFootPrint] = useState(false);
useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;

    const getCarbonFootPrint = async () => {
        setIsFetchingCarbonFootPrint(true);
        try {
            const data = await fetchCarbonFootPrint(signal);
            setCarbonFootPrint(data);
        } catch (error) {
            if (error.name !== "CanceledError") {
                console.error("Failed to fetch carbon footprint:", error);
            }
        } finally {
            setIsFetchingCarbonFootPrint(false);
        }
    };

    getCarbonFootPrint();

    return () => controller.abort();
}, []);

    const transformedCostPerDay = useMemo(() => transformCostData(vehicleMaintenanceCostPerDay), [vehicleMaintenanceCostPerDay]);
    const transformedCostPerKm = useMemo(() => transformCostData(vehicleMaintenanceCostPerKm), [vehicleMaintenanceCostPerKm]);
    const maintRequestCategory = useMemo(() => processMaintRequest(maintState.maintRequestCategory), [maintState.maintRequestCategory]);
    const totalMaintRequestCount = useMemo(() => Object.values(maintState.maintRequestCategory || {}).reduce((acc, val) => acc + val, 0), [maintState.maintRequestCategory]);

    const chartData = mode === "costPerDay" ? transformedCostPerDay : transformedCostPerKm;
    return (
        <>

            <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={4}>
                    <Card themecolors={themecolors}>
                        <Box display="flex" flexDirection="column" gap={2}>
                            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                            <h2>Total Vehicles Main Investments</h2>
                          <div>
                                <CustomTextField
                                id=''
                                select
                                label={''}
                                value={maintenanceValues.first}
                                name="first"
                                onChange={handleMaintenancetTimeChange}
                                margin='dense'
                                fullWidth
                            >
                                {currencies.map(option => (
                                    <MenuItem key={option.label} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </CustomTextField>
                          </div>
                            </div>

                          
                            <TotalInvoicesCard themescolors={themecolors} bgImage={onlineSvg} totalCost={totalInvoices} title={"totalInvoices"} translate={props.translate} currency={logInUser?.attributes?.currencyLabel || "AED"} />
                            <TotalInvoicesCard themescolors={themecolors} bgImage={MaintRequest} totalCost={totalMaintenanceRequest} title={"maintenanceRequest"} translate={props.translate} hideCurrency />
                        </Box>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Card themecolors={themecolors}>
                        <Box sx={{ display: "flex", gap: 2, mb: 2,justifyContent:"space-between", alignItems:"center"}}>
                        <h2>Maintenance Cost by Vehicles Classification</h2>

                            <div style={{display:'flex',justifyContent:'space-between',gap:4,paddingTop:"0.8rem"}}>
                            <p>Per Category</p>
                            <CustomTextField
                                id=''
                                select
                                label={''}
                                value={maintenanceValues.second}
                                name="second"
                                onChange={handleMaintenancetTimeChange}
                                margin='dense'
                                fullWidth
                            >
                                {currencies.map(option => (
                                    <MenuItem key={option.label} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </CustomTextField>
                            </div>

                        </Box>
                        {!vehicleClassificationData || vehicleClassificationData.length === 0 ? (
                            <div
                                style={{
                                    backgroundColor: "transparent",
                                    borderRadius: "8px",
                                    height: "100%",
                                }}
                            >
                                <MaintenanceItemEmpty />
                            </div>
                        ) : <Scrollbar start={{ height: "200px" }}>
                            <CostList data={vehicleClassificationData} currencyLabel={logInUser?.attributes?.currencyLabel || "AED"} themecolors={themecolors} />
                        </Scrollbar>
                        }

                    </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>

                    <Card themecolors={themecolors}>
                        <h2>Total Vehicles Size</h2>
                        {fleetSize.length === 0 ? (
                            <div
                                style={{
                                    backgroundColor: "transparent",
                                    borderRadius: "8px",
                                    height: "100%",
                                }}
                            >
                                <MaintenanceItemEmpty />
                            </div>) :
                            <ChartFleetSize data={fleetSize} />
                        }
                    </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Card themecolors={themecolors}>
                        {
                            isFetchingCarbonFootPrint?
                            (
                            <div
                                style={{
                                    backgroundColor: "transparent",
                                    borderRadius: "8px",
                                    height: "100%",
                                }}
                            >
                                <MaintenanceItemEmpty />
                            </div>
                        ):
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                                <h2>Decorbinazation</h2>
                                <div
                                    style={{
                                        borderRadius: "3px",
                                    }}
                                >
                                    <p
                                        style={{
                                            fontWeight: 400,
                                            fontSize: 12,
                                            color:themecolors?.textColor||"white",
                                            width: "100%",
                                        }}
                                    >
                                        {props.translate(
                                            "Let our experts help you go green and save money with your vehicle"
                                        )}{" "}
                                        <ContactSupportIcon style={{ fontSize: 14 }} />
                                    </p>
                                </div>
                                <div style={{ marginTop: "45px", paddingLeft: "10px" }}>
                                    <img src={co2svg} alt="" />
                                </div>
                                <p
                                    style={{
                                        textAlign: "left",
                                        fontWeight: 600,
                                        fontSize: 18,
                                        margin: "25px 0",
                                    }}
                                >
                                    <span
                                        style={{
                                            fontWeight: 700,
                                            display: "block",
                                            fontSize: 14,
                                        }}
                                    >
                                        {props.translate("total")} CO<sub>2</sub>{" "}
                                        {props.translate("emitted")}
                                    </span>{" "}
                                    &nbsp;&nbsp;&nbsp;
                                    <Tooltip
                                        title={
                                            <Typography style={{ fontSize: "14px" }}>
                                                {carbonFootPrint?.totalCarbonFootPrint?.toLocaleString() ||
                                                    ""}
                                            </Typography>
                                        }
                                        placement="bottom-start"
                                        enterDelay={300}
                                        classes={{ tooltip: "customTooltip" }}
                                    >
                                        <span
                                            style={{
                                                fontWeight: 800,
                                                fontSize: 14,
                                                color: themecolors?.menuActiveBackground||"#0a83a1",
                                                marginLeft: "20px",
                                            }}
                                        >
                                            {carbonFootPrint?.totalCarbonFootPrint?.toLocaleString(
                                                undefined,
                                                {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2,
                                                }
                                            ) || 0}{" "}
                                            {props.translate("metricTons")}
                                        </span>
                                    </Tooltip>
                                </p>
                            </Grid>
                            <Grid item xs={12} sm={6} md={6}>
                                <h3 style={{ marginTop: "0.8rem" }}>By Vehicle Category <span>
                                    <Tooltip
                                        title="All units are in Metric Tons"
                                        placement="bottom-start"
                                        enterDelay={300}
                                    >
                                        <InfoIcon
                                            style={{ fontSize: "16px" }}
                                            className="customTooltip"
                                        />
                                    </Tooltip>

                                </span>
                                </h3>
                                <Scrollbar style={{ height: "400px" }}>
                               <ul
  className="md-bar-graphlist"
  style={{ padding: 0, display: "flex", flexWrap: "wrap" }}
>
  {carbonFootPrint?.categoryWiseCarbonFootPrint?.map((item) => (
    <li
      key={item?.name}
      style={{
        backgroundColor: themecolors?.menuActiveBackground||"#0a83a1",
        color: themecolors?.textColor||"white",
        borderRadius: "8px",
        minWidth: "182px",
        height: "32px",
        margin: "0 10px 10px 0",
        listStyle: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 10px",
        fontSize: "14px",
        fontWeight: 500,
      }}
    >
      <span
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          flex: 1,
          paddingRight: "10px",
          textTransform: "capitalize",
          fontWeight: 400,
        }}
        title={props.translate(item?.name)}
      >
        {props.translate(item?.name)}
      </span>
      <span style={{ fontWeight: 600 }}>
        {item.value?.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }) || "0.00"}
      </span>
    </li>
  ))}
</ul>

                                </Scrollbar>
                            </Grid>
                        </Grid>
                        }
                    </Card>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                    <Card themecolors={themecolors}>
                        <h2>Top 20 Vehicles by Maintenance Cost</h2>
                        <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
                            <Button
                                fullWidth
                                className={mode === 'costPerDay' ? 'active' : 'button-inactive'}
                                onClick={() => setMode("costPerDay")}
                            >
                                Per Day
                            </Button>
                            <Button
                                fullWidth
                                className={mode === 'costPerKm' ? 'active' : 'button-inactive'}
                                onClick={() => setMode("costPerKm")}
                            >
                                Per KM
                            </Button>
                        </Box>

                        <PieChartMaint mode={mode} data={chartData} />
                    </Card>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                    <Card themecolors={themecolors}>
                        <h2 style={{ marginBottom: "3rem" }}>Top 20 Vehicles by Highest Maintenance Cost</h2>
                        {isFetchingTopHighest ? (
                            <div
                                style={{
                                    backgroundColor: "transparent",
                                    borderRadius: "8px",
                                    height: "100%",
                                }}
                            >
                                <MaintenanceItemEmpty />
                            </div>
                        ) :
                            <PieChartMaint mode={mode} data={top20HighestMaintCost} />
                        }
                    </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Card themecolors={themecolors}>
                        <Box display="flex" flexDirection="column" gap={1}>
                            <div style={{display:'flex',alignContent:"center",justifyContent:"space-between"}}>

                            <h2>High-Demand Parts & Services</h2>
                       <div>
                             <CustomTextField
                                id=''
                                select
                                label={''}
                                value={maintenanceValues.fourth}
                                name="fourth"
                                onChange={handleMaintenancetTimeChange}
                                margin='dense'
                                fullWidth
                            >
                                {currencies.map(option => (
                                    <MenuItem key={option.label} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </CustomTextField>
                       </div>
                            </div>


                            <Box sx={{ display: "flex", mb: 2, width: '100%', gap: 2 }}>
                                {buttons.map(btn => (
                                    <Button
                                        key={btn.value}
                                        fullWidth
                                        className={serviceBtn === btn.value ? 'active' : 'button-inactive'}
                                        onClick={() => setServiceBtn(btn.value)}
                                    >
                                        {btn.label}
                                    </Button>
                                ))}
                            </Box>
                            {isFetchingServices ? (
                                <div
                                    style={{
                                        backgroundColor: "transparent",
                                        borderRadius: "8px",
                                        height: "100%",
                                    }}
                                >
                                    <MaintenanceItemEmpty />
                                </div>
                            ) : (
                                <>
                                    {serviceBtn === "topServices" && usedService.length > 0 ? (
                                        <MultiLinearProgress data={usedService} />
                                    ) : serviceBtn === "topServices" ? (
                                        <MaintenanceItemEmpty />
                                    ) : null}

                                    {serviceBtn === "topParts" && usedParts.length > 0 ? (
                                        <MultiLinearProgress data={usedParts} />
                                    ) : serviceBtn === "topParts" ? (
                                        <MaintenanceItemEmpty />
                                    ) : null}

                                    {serviceBtn === "topPackages" && usedPackages.length > 0 ? (
                                        <MultiLinearProgress data={usedPackages} />
                                    ) : serviceBtn === "topPackages" ? (
                                        <MaintenanceItemEmpty />
                                    ) : null}
                                </>
                            )}

                        </Box>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Card themecolors={themecolors}>
                        <Box display="flex" flexDirection="column" gap={1}>
                            <div style={{display:'flex',alignContent:"center",justifyContent:"space-between"}}>

                            <h2>Maintenance Request Categories</h2>
                            <div>

                            <CustomTextField
                                id=''
                                select
                                value={maintenanceValues.third}
                                name="third"
                                onChange={handleMaintenancetTimeChange}
                                margin='dense'
                                fullWidth
                            >
                                {currencies.map(option => (
                                    <MenuItem key={option.label} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </CustomTextField>
                            </div>
                            </div>



                            {isFetchingMaintenanceReqst ? (
                                <div
                                    style={{
                                        backgroundColor: "transparent",
                                        borderRadius: "8px",
                                        height: "100%",
                                    }}
                                >
                                    <MaintenanceItemEmpty />
                                </div>) :
                                <>
                                    <Box sx={{ display: "flex", width: '100%', justifyContent: "space-between", alignItems: "center" }}>
                                        <h2>Total Maintenance Request Count</h2>
                                        <h2 style={{ color: themecolors?.textColor }}>{totalMaintRequestCount}</h2>
                                    </Box>
                                    <MultiLinearProgress data={maintRequestCategory} />
                                </>
                            }
                        </Box>
                    </Card>
                </Grid>

            </Grid>
        </>

    )
}

export default MaintenanceDashboard